<div class="modal-content">
  <div class="modal-toggle-wrapper social-profile text-start dark-sign-up">
    <h4 class="modal-header justify-content-center border-0 text-dark">Base de Conhecimento</h4>
    <div class="modal-body">
      <input class="form-control mb-3" type="text" [(ngModel)]="searchQuery" placeholder="Buscar pelo titulo do artigo..." />

      <div *ngIf="isLoading" class="text-center">
        <i class="fa fa-spinner fa-spin"></i> Carregando artigos...
      </div>

      <div *ngIf="!isLoading && articles.length === 0" class="text-center">
        Nenhum artigo encontrado.
      </div>

      <div class="articles-list" *ngIf="!isLoading && articles.length > 0">
        <div *ngFor="let article of filteredArticles" 
             class="article-item" 
             [class.selected]="article === selectedArticle"
             (click)="selectedArticle = article">
          <h3>{{ article.title }}</h3>
          <p><strong>Data:</strong> {{ article.createdDate }}</p>
          <p *ngIf="article.textContent">
            {{ article.textContent.length > 200 ? (article.textContent | slice:0:200) + '...' : article.textContent }}
          </p>
          
          <button class="btn btn-link" (click)="openArticle(article); $event.stopPropagation()">Ver completo</button>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-between align-items-center">
      <!-- Contador de artigos (alinhado à esquerda) -->
      <p class="article-counter m-0">
        Mostrando {{ filteredArticles.length }} de {{ articles.length }} artigos
      </p>
    
      <!-- Botões (alinhados à direita) -->
      <div>
        <button class="btn btn-secondary me-2" (click)="closeModal()">Cancelar</button>
        <button class="btn btn-primary" [disabled]="!selectedArticle" (click)="confirmSelection()">Incluir artigo</button>
      </div>
    </div>
    
  </div>
</div>
